<mat-card class="my-card">
    <form [formGroup]="detailsForm" class="my-form">
        <mat-card-content>
            <mat-form-field class="full-width">
                <mat-label>Select Location Code</mat-label>
                <mat-select  [formControl]="locCodes"  required>
                    <mat-option *ngFor="let code of locationCodes" ngDefaultControl [value]="code">{{code}}</mat-option>
                </mat-select>
                <mat-error *ngIf="locCodes.invalid && (locCodes.dirty || locCodes.touched)">{{GetLocationDetailsErrorMessage()}}</mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <input matInput [disabled]="false" [matDatepicker]="fromPicker" placeholder="From date">
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="full-width">
                <input matInput [disabled]="false" [matDatepicker]="toPicker" placeholder="To date">
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>
            <table mat-table [dataSource]="transactions" class="mat-elevation-z8">
                <!-- Item Column -->
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef> Item </th>
                    <td mat-cell *matCellDef="let transaction"> {{transaction.item}} </td>
                    <td mat-footer-cell *matFooterCellDef> Total </td>
                </ng-container>
            
                <!-- Cost Column -->
                <ng-container matColumnDef="cost">
                    <th mat-header-cell *matHeaderCellDef> Cost </th>
                    <td mat-cell *matCellDef="let transaction"> {{transaction.cost | currency:'INR':'symbol-narrow'}} </td>
                    <td mat-footer-cell *matFooterCellDef> {{getTotalCost() | currency:'INR':'symbol-narrow'}} </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>
        </mat-card-content>
    <mat-card-actions style="padding: 0.5rem; width: 50%; align-self: center;">
     <button mat-fab color="accent">Return</button>
    </mat-card-actions>
    </form>
</mat-card>